import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"c-socialweb\">\n  {{yield}}\n</div>",{ moduleName: "mewe/pods/components/cms/routable/socialweb/template.hbs" })